import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/header";
import Sidenav from "../components/sidenav";
import ChatContent from "./chat-content";
import './chat.css';  // CSS file for styling

const Chat = () => {
  const [isExpanded, setExpanded] = useState(false); // For expanding Sidenav on large screens
  const [openNewChat, setOpenNewChat] = useState(false);
  const [showSidenav, setShowSidenav] = useState(window.innerWidth > 768); // Initially show Sidenav on larger screens
  const navigate = useNavigate();

  // Handle window resizing to show/hide Sidenav on mobile/desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setShowSidenav(false); // Hide Sidenav on small screens by default
      } else {
        setShowSidenav(true);  // Show Sidenav on large screens
      }
    };

    window.addEventListener("resize", handleResize);

    // Clean up the event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleExpanded = () => setExpanded(!isExpanded);

  const changeChatContentState = () => {
    setOpenNewChat(!openNewChat);
  };

  const toggleSidenav = () => setShowSidenav(!showSidenav); // Toggle Sidenav visibility on small screens

  return (
    <>
      <Header onBurgerClick={toggleSidenav} /> {/* Pass burger click handler */}
      <div className="chat-container">
        {/* Conditionally render Sidenav based on screen size and state */}
        <Sidenav
          isExpanded={isExpanded}
          toggleExpanded={toggleExpanded}
          changeChatContentState={changeChatContentState}
          showSidenav={showSidenav}
          setShowSidenav={setShowSidenav} // Pass the state setter function
        />
        <div className="chat-content-container">
          <ChatContent chatContentState={openNewChat} />
        </div>
      </div>
    </>
  );
};

export default Chat;
